export const VERIFY_EMAIL_URL = () => `${window.location.origin}/auth/verify-email`;

export const CHANGE_EMAIL_URL = () => `${window.location.origin}/account/change-email`;

export const CONFIRM_NEW_EMAIL_URL = () => `${window.location.origin}/account/confirm-email`;

export const RESET_PASSWORD_URL = () => `${window.location.origin}/auth/reset-password`;